
//firebase code to place order 
import { collection, doc, setDoc, addDoc } from "firebase/firestore";
import {db} from './firebase';
import { getAuth } from 'firebase/auth';
import { v4 as uuid } from 'uuid';
   
    //place orders without login
   export const placeOrder = async ( body) => {
    const auth = getAuth();
    const user = auth.currentUser;
        const unique_id = uuid();
       
        // await setDoc(doc(db, "Orders",unique_id),{
        //     data : body
        // })
        if (user) {
            // User is logged in, save data to their document in the "users" collection
            const usersCollection = collection(db, 'users');
            const userDocRef = doc(usersCollection, unique_id);
        
            try {
              await setDoc(userDocRef, body);
              console.log('Data added to the user document in the users collection');
            } catch (error) {
              console.error('Error adding data to user document:', error);
            }
          } else {
            // User is not logged in, save data to the "leads" collection
            const leadsCollection = collection(db, 'leads');
        
            try {
              await addDoc(leadsCollection, body);
              console.log('Data added to the leads collection');
            } catch (error) {
              console.error('Error adding data to leads collection:', error);
            }
          }
        
    }
